import Autocomplete from '@mui/material/Autocomplete';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Container from '@mui/system/Container';
import Stack from '@mui/system/Stack';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { hasErrors } from '../../../common/enums';
import { Territory } from '../../../common/models/territories';
import { userLogged } from '../../../common/selectors/user';
import { editTerritorySlice } from '../../../common/store/editTerritorySlice';
import { AppState, appStore, franchiseSelector, territorySelector } from '../../../common/store/store';
import { territorySlice } from '../../../common/store/territories';
import { postData } from '../../api';
import { Loading } from '../Loading';



export const EditTerritory = () => {

    const { id } = useParams();

    const [loading, setLoading] = React.useState(false);
    const user = useSelector((state: AppState) => userLogged(state));
    const territory = useSelector((state: AppState) => territorySelector.selectById(state, parseInt(id ?? '0')));
    const franchises = useSelector((state: AppState) => franchiseSelector.selectAll(state));
    const editingTerritory = useSelector((state: AppState) => state.editTerritory.territory);
    const [err, setErr] = React.useState<ResponseError[] | undefined>();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (territory) {
            appStore.dispatch(editTerritorySlice.actions.update(territory));
        }
    }, []);


    const onSaveClick = async () => {
        setLoading(true);
        try {
            const result = await postData<Territory>('territories', editingTerritory);
            setLoading(false);
            if (!hasErrors(result)) {
                setErr(undefined);
                appStore.dispatch(editTerritorySlice.actions.update(result));
                appStore.dispatch(territorySlice.actions.upsertOne(result));
            } else {
                setErr(result);
            }
        } catch (err) {
            setLoading(false);
            alert('Un erreur a eu lieu');
        }


    };

    if (editingTerritory && territory) {

        return <Master>
            <Container maxWidth={false}>
                {loading ? <Loading /> : null}
                <Typography variant='h1'>{territory.name}</Typography>
                <Breadcrumbs>
                    <Link to={'/admin/territoires'} onClick={() => { navigate('/admin/territoires'); }}>Territoires</Link>
                    <Typography>{editingTerritory.name}</Typography>
                </Breadcrumbs>

                <Typography variant='h2'>Informations générales</Typography>
                <Stack spacing={2}>
                    <TextField
                        fullWidth
                        label='Nom de la franchise'
                        name='name'
                        value={editingTerritory.name}
                        onChange={(event) => {
                            appStore.dispatch(editTerritorySlice.actions.update({ name: event.target.value }));
                        }}
                        error={!!err?.find(p => p.param === 'name')}
                        helperText={err?.find(p => p.param === 'name')?.msg}
                    />
                    {user?.isAdmin ? <FormControl fullWidth error={!!err?.find(p => p.param == 'franchiseId')}>
                        <InputLabel id="demo-simple-select-label">Franchise qui détient ce territoire</InputLabel>
                        <Select
                            fullWidth
                            value={editingTerritory.franchiseId}
                            onChange={(event) => {
                                const value = event.target.value ? parseInt(event.target.value + '') : null;
                                appStore.dispatch(editTerritorySlice.actions.update({ franchiseId: value ?? null }));
                            }}>
                            {franchises.map(franchise => <MenuItem key={franchise.id} value={franchise.id}>{franchise.name}</MenuItem>)}
                            <MenuItem key="aucune" value={0}>Ne spécifier aucune franchise</MenuItem>
                        </Select>
                        <FormHelperText>{err?.find(p => p.param == 'franchiseId')?.msg}</FormHelperText>
                    </FormControl> : null}
                </Stack>

                <Typography variant='h2'>Zones (villes et municipalités faisant partie de ce territoire)</Typography>
                <Autocomplete
                    multiple
                    id="tags-filled"
                    defaultValue={editingTerritory.regions ?? undefined}
                    options={editingTerritory.regions ?? []}
                    value={editingTerritory.regions ?? []}
                    freeSolo
                    onChange={(_e, value: string[]) => {
                        console.log('on change', value);
                        const vals: string[] = [];
                        for (let i = 0; i < value.length; i++) {
                            const arr = value[i].split(/[\n,]/);
                            arr.forEach(p => {
                                if (p.trim()) {
                                    vals.push(p.trim());
                                }
                            });
                        }
                        appStore.dispatch(editTerritorySlice.actions.update({ regions: vals }));
                    }}
                    renderTags={(value: readonly string[], getTagProps) =>
                        value.map((option: string, index: number) => {
                            const { key, ...tagProps } = getTagProps({ index });
                            return (
                                <Chip variant="outlined" label={option} key={key} {...tagProps} />
                            );
                        })
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            multiline
                            variant="filled"
                            placeholder="nom de la ville / municipalité"
                        />
                    )}
                />

                <Button disabled={loading} size='large' variant='contained' onClick={onSaveClick}>Sauvegarder</Button>

            </Container>
        </Master >;
    } else {
        return <p>Not found</p>;
    }
};
